var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-page"},[_c('main',{staticClass:"main-content"},[_c('div',{staticClass:"page-title"},[(_vm.msg)?_c('div',[_vm._v(" "+_vm._s(_vm.msg)+" ")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }